import { Wind, CloudLightning, Droplets, Zap, Home, Building2, ShieldCheck, Thermometer, Bug, Anchor } from "lucide-react";

export const locations = {
  miami: {
    name: "Miami",
    tagline: "MIAMI-DADE — HVHZ TERRITORY",
    headline: ["HVHZ-grade inspections", "for the toughest code", "in America."],
    intro:
      "Miami sits inside the High-Velocity Hurricane Zone — the strictest building standard in the country. Inspections here demand NOA-rated product knowledge, salt-air corrosion grading, and condo fluency.",
    img: "https://images.unsplash.com/photo-1753194931716-1add84f0b6ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBmbG9yaWRhJTIwaG9tZSUyMGV4dGVyaW9yJTIwcG9vbHxlbnwwfHx8fDE3OTA0NDc5MDF8MA&ixlib=rb-4.1.0&q=85",
    needs: [
      { icon: Wind, title: "HVHZ Wind Mitigation", text: "Miami-Dade NOA product documentation, roof deck attachment, and secondary water resistance — the features that unlock the largest premium credits in Florida." },
      { icon: ShieldCheck, title: "Impact Opening Protection", text: "Rated shutters, impact glazing, and door assemblies verified against approved product listings, opening by opening." },
      { icon: Building2, title: "Condo & High-Rise Units", text: "Unit-level electrical, plumbing, and HVAC plus balcony condition — with pointers on the association documents your lender will request." },
      { icon: Droplets, title: "Salt-Air Corrosion Survey", text: "Coastal exposure corrodes panels, condenser coils, and fasteners years early. We grade remaining service life honestly." },
    ],
    stats: [
      { value: "HVHZ", label: "CODE ZONE" },
      { value: "40%", label: "MAX WIND CREDIT" },
      { value: "24 HR", label: "REPORT TURNAROUND" },
    ],
  },
  "fort-lauderdale": {
    name: "Fort Lauderdale",
    slug: "fort-lauderdale",
    tagline: "FORT LAUDERDALE — BROWARD COUNTY",
    headline: ["Canal-front charm.", "Salt air. Storm season.", "Zero surprises."],
    intro:
      "Fort Lauderdale's canal-front neighborhoods and 1950s–70s ranch stock sit inside the High-Velocity Hurricane Zone. Salt air, tidal moisture, and aging electrical systems make local knowledge non-negotiable.",
    img: "https://images.pexels.com/photos/8925427/pexels-photo-8925427.jpeg",
    needs: [
      { icon: Wind, title: "HVHZ Wind Mitigation", text: "Broward is HVHZ territory — deck attachment, roof-to-wall connections, and secondary water resistance documented for the biggest available premium credits." },
      { icon: Droplets, title: "Canal & Flood-Zone Moisture", text: "Tidal surge and high water tables push moisture into slabs and block walls — thermal imaging finds it before your lender's appraiser does." },
      { icon: Anchor, title: "Seawall & Waterfront Red Flags", text: "Visible seawall bowing, cap cracks, and settlement flagged during the inspection so you can bring in a marine specialist before closing." },
      { icon: Zap, title: "Mid-Century Electrical", text: "Federal Pacific, Zinsco, and aluminum branch circuits are common in Broward's ranch homes — identified and reported in insurer-ready language." },
    ],
    stats: [
      { value: "HVHZ", label: "CODE ZONE" },
      { value: "1950s", label: "RANCH-STOCK ERA" },
      { value: "24 HR", label: "REPORT TURNAROUND" },
    ],
  },
  "west-palm-beach": {
    name: "West Palm Beach",
    slug: "west-palm-beach",
    tagline: "WEST PALM BEACH — PALM BEACH COUNTY",
    headline: ["Historic charm.", "Hurricane codes.", "We check both."],
    intro:
      "From 1920s Old Northwood and Flamingo Park homes to brand-new western communities, Palm Beach County spans a century of construction — and insurers treat each era very differently.",
    img: "https://images.unsplash.com/photo-1753194931766-211c9f563156?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBmbG9yaWRhJTIwaG9tZSUyMGV4dGVyaW9yJTIwcG9vbHxlbnwwfHx8fDE3OTA0NDc5MDF8MA&ixlib=rb-4.1.0&q=85",
    needs: [
      { icon: Home, title: "Historic Home Expertise", text: "1920s construction means retrofit wiring, galvanized plumbing, and settled foundations — evaluated with respect for original fabric and modern safety." },
      { icon: Wind, title: "Wind Mitigation Credits", text: "Hip roof geometry, straps and clips, and impact opening protection documented to cut Palm Beach County premiums." },
      { icon: Droplets, title: "Cast-Iron Drain Failures", text: "Pre-1975 homes often hide corroded cast-iron drains — we trace moisture evidence and flag when a camera scope is worth the cost." },
      { icon: ShieldCheck, title: "4-Point for Older Stock", text: "Carriers require 4-point inspections on homes 20+ years old across the county — roof, electrical, HVAC, and plumbing in one visit." },
    ],
    stats: [
      { value: "1920s", label: "HISTORIC DISTRICTS" },
      { value: "20+ YR", label: "4-POINT TRIGGER" },
      { value: "24 HR", label: "REPORT TURNAROUND" },
    ],
  },
};
